export function crossBorderSwift(raw: unknown): string {
  if (!raw || typeof raw !== 'object') {
    return ''
  }
  const swift = (raw as {swift?: unknown}).swift
  return typeof swift === 'string' ? swift.trim() : ''
}

export function crossBorderRawPayload(raw: unknown): Record<string, unknown> {
  const next: Record<string, unknown> = raw && typeof raw === 'object'
    ? {...(raw as Record<string, unknown>)}
    : {}
  const swift = crossBorderSwift(next)
  if (swift) {
    next.swift = swift
  } else {
    delete next.swift
  }
  return next
}

export function crossBorderAccountRequisites(value: string | null | undefined): string {
  return `${value ?? ''}`.replace(/\D/g, '')
}
